import apiClient from './apiClient';

const API_URL = '/localidades';

// Obtener todas las localidades
export const getLocalidades = async () => {
    const response = await apiClient.get(API_URL);
    return response.data;
};

// Obtener localidades por provincia
export const getLocalidadesPorProvincia = async (provinciaId) => {
    const response = await apiClient.get(`${API_URL}/provincia/${provinciaId}`);
    return response.data;
};

// Obtener localidades por división primaria
export const getLocalidadesPorDivision = async (divisionId) => {
    const response = await apiClient.get(`${API_URL}/division/${divisionId}`);
    return response.data;
};

// Buscar localidades por nombre
export const buscarLocalidades = async (nombre) => {
    const response = await apiClient.get(`${API_URL}/buscar`, { params: { nombre } });
    return response.data;
};
